import config from '@/configs/google'

class GoogleSignin {
  constructor () {
    this.callback = '_signin' + Math.floor(Math.random() * 10000)
    this.ready = false
    this.init()
  }

  init () {
    window[this.callback] = () => (this.onScriptLoaded())
    this.doScriptLoad()
  }

  doScriptLoad () {
    const dom = document.createElement('script')
    dom.src = `https://apis.google.com/js/platform.js?onload=${this.callback}`
    dom.async = true
    dom.defer = true
    document.body.append(dom)
  }

  async onScriptLoaded () {
    await new Promise(
      resolve => (gapi.load('auth2', resolve))
    )

    const options = {
      apiKey: config.apiKey,
      clientId: config.clientId,
      discoveryDocs: config.discoveryDocs,
      scope: config.scopes.join(' '),
      hosted_domain: 'syndacast.com'
    }

    gapi.auth2.init(options)
    this.ready = true
  }

  doWaitScriptLoaded () {
    const $check = (resolve) => {
      (this.ready) ? resolve() : setTimeout($check, 100, resolve)
    }
    return new Promise(resolve => $check(resolve))
  }

  async doSingIn () {
    await this.doWaitScriptLoaded()
    const auth = gapi.auth2.getAuthInstance()
    try {
      const user = await auth.signIn()
      const basic = user.getBasicProfile()
      const token = user.getAuthResponse()

      const profile = {
        id: basic.getId(),
        name: basic.getName(),
        email: basic.getEmail(),
        photo: basic.getImageUrl()
      }

      return { profile, token }
    } catch (e) {
      throw new Error(e)
    }
  }

  async doSingOut () {
    await this.doWaitScriptLoaded()
    return gapi.auth2.getAuthInstance().signOut()
  }

  async doRefreshToken () {
    await this.doWaitScriptLoaded()
    const auth = gapi.auth2.getAuthInstance()
    const user = auth.currentUser.get()
    const token = await user.reloadAuthResponse()
    return token
  }

  signIn () {
    return this.doSingIn()
  }

  signOut () {
    return this.doSingOut()
  }

  refreshToken () {
    return this.doRefreshToken()
  }
}

export default new GoogleSignin()
